import React from 'react'
import { CircleFill } from 'react-bootstrap-icons'
import ReflectionPromptName from '../../reflection-prompt/name'
import { get } from 'lodash'
import useClientLocation from '../../../hooks/use-client-location'
import moment from 'moment'
import { StudentReflectionStatusIndicator } from '../../../features/student-reflection-status-indicator'

const ReflectionItem = ({
    userReflection = {},
    userId
}) => {
    const { endpoints, url, toLocation } = useClientLocation()
    const unfilled = !get(userReflection, 'content')
    const canFill = moment().isSameOrAfter(userReflection.startDate, 'day') && moment().isSameOrBefore(userReflection.endDate, 'day')
    const isNew = false;//unfilled && canFill

    return (
        <React.Fragment>
            <div
                style={{
                    cursor: 'pointer',
                    position: 'relative',
                    backgroundColor: isNew ? 'rgb( 48, 155, 248)' : undefined,
                    color: isNew ? 'white' : undefined,
                    paddingTop: '20px',
                    paddingBottom: '20px',
                    paddingLeft: '20px',
                    paddingRight: '20px',
                    display: 'flex',
                    borderTop: '1px solid rgb( 201, 230, 253)',
                    justifyContent: 'center'
                }}
                onClick={() => toLocation(url(endpoints.USER_REFLECTION, { userId, promptId: userReflection.id}))}
            >
                {isNew &&
                <div
                    style={{
                        position: 'absolute',
                        top: '-10px',
                        right: '-10px',
                        color: 'red'
                    }}
                >
                    <CircleFill />
                </div>
                }
                <div style={{ flexGrow: '1', fontWeight: '600' }} className='ellipsis-truncate align-self-center'>
                    <ReflectionPromptName reflectionPrompt={userReflection} />
                </div>
                {isNew &&
                <div className='align-self-center'>NEW</div>
                }
                <StudentReflectionStatusIndicator userReflection={userReflection} />
            </div>
        </React.Fragment>
    )
}

export default ReflectionItem